module.exports = __webpack_public_path__ + "static/img/zx-button.daf16298.png";